"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const isOnServer_1 = __importDefault(require("./isOnServer.js"));
const constants_1 = require("./constants.js");
/**
 * Checks for a log level override defined as a cookie.
 * This will only  affect client-side logging,
 * as we don't currently pass server-request when initializing this library
 */
const getCookieOverride = () => {
    if ((0, isOnServer_1.default)())
        return undefined;
    const overrideCookie = js_cookie_1.default.get('nw-log-level');
    if (!overrideCookie)
        return undefined;
    if (!constants_1.LevelPriority[overrideCookie])
        return undefined;
    return overrideCookie;
};
exports.default = getCookieOverride;
